import { useContext, useState } from "react";
import { login } from "../../authContext/apiCalls";
import { AuthContext } from "../../authContext/AuthContext";
import { Link } from "react-router-dom";

import "./login.scss";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mensaje, setMensaje] = useState("");
  
  const { dispatch } = useContext(AuthContext);

  let usert=useContext(AuthContext).error;

  const handleLogin = (e) => {
    e.preventDefault();
    if(email==="" || password==="")
    {
      setMensaje("Ingrese sus credenciales ...");
    }
    if(email!=="" && password!=="")
    {
      setMensaje("Validando credenciales ...");
      login({ email, password }, dispatch);
    }
 
    
  };
  return (
    <div className="login">
      <div className="top">
        <div className="wrapper">
          <img
            className="logo"
            src="https://metrowancore.nextwarela.com/media/images/logo.png"
            alt=""
          />
        </div>
      </div>
      <div className="container">
        <form>
          <h1>Iniciar Sesión</h1>
          <input
            type="email"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
            
          />
          <button className="loginButton" onClick={handleLogin}>
            Ingresar
          </button>
          <span>
            
            <Link to="/register"><b>Crear cuenta.</b></Link> 
          </span>
          <span>
            
            <Link to="/recuperar"><b>Recuperar cuenta.</b></Link> 
          </span>

          <span>{usert}</span>
          
        </form>
      </div>
    </div>
  );
}